const featureFlagQueries = {
  all: () => ["feature-flags"],
  get: (flagName: string) => ["feature-flags", flagName],
  states: (flagNames: Array<string>) => ["feature-flag-states", flagNames],
};

export default featureFlagQueries;
